import "./side-effects.js";
import { BarcodeDetector as t, setZXingModuleOverrides as d } from "./pure.js";
export { t as BarcodeDetector, d as setZXingModuleOverrides };